<template>
  <div>
    <b-modal
      id="parcelasList"
      ref="parcelasList"
      button-size="sm"
      no-close-on-backdrop
      ok-only
      :no-stacking="stacking"
      ok-title="Ok"
      size="lg"
      :no-enforce-focus="true"
    >
      <div slot="modal-title">
        <h4>{{ 'Parcelas - ' + parcelamento.razaoSocial }}</h4>
        <fieldset class="font-weight-bold text-muted small">
          Nesta tela estão as ultimas parcelas lidas pelo Monitor, você pode mandar as guias por email ou baixar
        </fieldset>
      </div>

      <b-row
        class="mb-1 mr-0 justify-content-end mb-1"
      >
        <b-col
          cols="auto"
          class="p-0 d-flex align-items-center"
        >
          <modal-whatsapp-em-lote
            :tipo-rotina="getTipoParcelamento()"
            :linhas-selecionadas="mapear()"
            :row="criarRow()"
            :api="apiParcela"
          />
          <download-em-excel
            :tipo="tipoParcelamento"
            :especifico="true"
            :api="apiParcela"
            :linhas-selecionadas="mapear()"
            :todas-linhas="mapear(true)"
            :filtro="{}"
            style="font-size: 11.5px; margin-right: 1rem;"
          />
          <button
            v-b-tooltip.hover
            style="font-size: 11.5px; padding: .40rem;"
            :title="`Realizar o download das parcelas selecionadas`"
            class="btn btn-sm btn-outline-primary mr-1"
            @click="baixarDocumentos()"
          >
            <feather-icon
              icon="DownloadIcon"
              class="text-primary"
              size="18"
            />
            Baixar em lote
          </button>
        </b-col>
      </b-row>

      <h5
        v-if="showParc"
        style=""
      >
        Histórico <span style="float: right;">{{ parcelamento.totalParcelas }}</span>
      </h5>

      <menu-lateral
        :pendencias="parcelamento.tributos"
        @selecionado="selecionarTributo"
      />

      <visualizacao
        v-model="parcelasSelecionadas"
        :grupo-tributo="tributoSelecionado"
        :tipo-parcelamento="tipoParcelamento"
        :razao-social="parcelamento.razaoSocial"
        @envioEmail="openEnvioEmail($event)"
        @envioWhatsapp="openEnvioWhatsapp($event)"
        @mostrarGuia="visualizarGuia($event)"
        @selected-items="getLinhasSelecionadas"
        @baixar-documentos="baixarDocumentos"
      >
        <template
          slot="acao-observacao"
          slot-scope="{ props}"
        >
          <b-btn
            v-b-tooltip.hover
            title="Observação"
            variant="none"
            class="btn-none rounded-pill m-0 icone-acao p-0"
            @click="$emit('openObservacoes', props)"
          >
            <font-awesome-icon
              icon="fa-regular fa-message"
              :class="{
                'text-success': props.todasObservacoesLidas,
                'text-warning': !props.todasObservacoesLidas && props.temObservacoesNaoLidas,
                'text-primary': !props.todasObservacoesLidas && !props.temObservacoesNaoLidas
              }"
            />
          </b-btn>
        </template>
      </visualizacao>
    </b-modal>
  </div>
</template>

<style lang="scss">
.modal:nth-of-type(even) {
    z-index: 1052 !important;
}
.modal-backdrop.show:nth-of-type(even) {
    z-index: 1051 !important;
}
</style>

<script>
import apiParcelaGeral from '@/app/parcelamentos/shared/components/parcelas/services/api'

export default {
  name: 'ParcelaView',
  components: {
    ModalWhatsappEmLote: () => import('@/app/shared/components/whatsapp/ModalWhatsappEmLote.vue'),
    MenuLateral: () => import('./components/menu-lateral/MenuLateral.vue'),
    Visualizacao: () => import('./components/visualizacao/Visualizacao.vue'),
    DownloadEmExcel: () => import('@app/download-excel/DownloadEmExcel.vue'),
  },
  props: {
    parcelamento: {
      type: Object,
      required: true,
    },
    requestParcelas: {
      type: Function,
      required: true,
    },
    tipoParcelamento: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      stacking: true,
      mostrarArquivo: false,
      urlArquivo: '',
      parcelas: [],
      tributoSelecionado: '',
      parcelasSelecionadas: [],
      colunas: [
        {
          key: 'competencia', label: 'Competência', tdClass: 'col-2',
        },
        {
          key: 'numeroParcela', label: 'Parcela', tdClass: 'col-2',
        },
        {
          key: 'status', label: 'Status',
        },
        {
          key: 'valor', label: 'Valor (R$)',
        }],
      showParc: false,
      showParcEntrada: false,
      linhasSelecionadas: [],
      apiParcela: apiParcelaGeral(this.tipoParcelamento),
    }
  },
  methods: {
    mapear(todos = false) {
      if (this.parcelas && this.parcelas.length !== 0) {
        if (todos) {
          return this.parcelas.map(item => item.id)
        }
        return this.linhasSelecionadas
      }
      return null
    },
    baixarDocumentos(id) {
      if (id || this.linhasSelecionadas.length > 0) {
        this.$emit('loading', true)
        this.apiParcela.baixarSelecionados(id || this.linhasSelecionadas)
          .then(payload => {
            window.open(payload.data)
            this.$sucesso(`Download da ${this.tipoParcelamento} finalizado.`)
          })
          .catch(err => {
            this.$erro(err.message || 'Ocorreu um erro no download.')
            throw err
          })
          .finally(() => {
            this.$emit('loading', false)
          })
      } else {
        this.$erro(`Não há nenhuma ${this.tipoParcelamento} selecionada para download!`)
      }
    },
    getLinhasSelecionadas(linhas) {
      this.linhasSelecionadas = linhas
    },
    carregarParcelas() {
      if (this.requestParcelas) {
        this.requestParcelas(this.parcelamento.id)
          .then(payload => {
            this.parcelas = payload.data
            this.parcelasSelecionadas = this.parcelas.filter(find => find.tributo.toLowerCase() === this.tributoSelecionado.toLowerCase())
          })
          .catch(err => {
            throw err
          })
      }
    },
    selecionarTributo(tributo) {
      this.tributoSelecionado = tributo
      this.parcelasSelecionadas = this.parcelas.filter(find => find.tributo.toLowerCase() === tributo.toLowerCase())
    },
    show() {
      this.carregarParcelas()
      this.$refs.parcelasList.show()
    },
    openEnvioEmail(id) {
      this.$emit('envioEmail', { id: this.parcelamento.id, parcelaId: id })
    },
    openEnvioWhatsapp(id) {
      this.$emit('envioWhatsapp', { id: this.parcelamento.id, parcelaId: id })
    },
    visualizarGuia(id) {
      this.$emit('mostrarGuia', { id: this.parcelamento.id, parcelaId: id })
    },
    hide() {
      this.$refs.parcelasList.hide()
    },
    getTipoParcelamento() {
      return this.tipoParcelamento === 'nao-previdenciario'
        ? 'NÃO PREVIDENCIÁRIO'
        : this.tipoParcelamento.toUpperCase().replace('_', ' ')
    },
    criarRow(item = null) {
      const baseRow = {
        id: this.parcelamento.id,
        razaoSocial: this.parcelamento.razaoSocial,
      }
      if (item) {
        baseRow.parcelaId = item.id
      }

      return baseRow
    },
  },
}

</script>
